import React, { useState } from "react";
import axios from "axios";
import API_URL from "../../Config";
import { IoClose } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import "../Customer/customer.css";

const AddProduct = ({ onClose, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [productData, setProductData] = useState({
    product_code: "",
    product_name: "",
    uom: "",
    is_active: 1, // ✅ backend expects number
  });

  const [errors, setErrors] = useState({});

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const err = {};

    if (!productData.product_code.trim())
      err.product_code = "Product code is required";

    if (!productData.product_name.trim())
      err.product_name = "Product name is required";

    if (!productData.uom.trim()) err.uom = "UOM is required";

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showSnackbar("Please fill all required fields", "error");
      return;
    }

    try {
      setIsLoading(true);

      const authKey = localStorage.getItem("authKey");

      const payload = {
        product_code: productData.product_code,
        product_name: productData.product_name,
        uom: productData.uom,
        is_active: productData.is_active, // ✅ backend expects this
      };

      const response = await axios.post(
        `${API_URL}/api/barrel/products`,
        payload,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      if (response.status === 201 || response.status === 200) {
        showSnackbar("Product added successfully", "success");
        setTimeout(() => onSuccess(), 800);
      }
    } catch (error) {
      if (error.response?.status === 409) {
        showSnackbar("Product with this code already exists", "error");
      } else {
        showSnackbar("Failed to add product", "error");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="barrels_popup-overlay">
        <div className="barrels_popup-modal">
          {/* HEADER */}
          <div className="barrels_popup-header">
            <h4>Add Product</h4>
            <span className="barrels_close-btn" onClick={onClose}>
              <IoClose />
            </span>
          </div>

          {/* BODY */}
          <div className="barrels_popup-body">
            <div className="barrels_form-group">
              <label>Product Code *</label>
              <input
                type="text"
                name="product_code"
                value={productData.product_code}
                onChange={handleChange}
              />
              {errors.product_code && (
                <span className="barrels_error">{errors.product_code}</span>
              )}
            </div>

            <div className="barrels_form-group">
              <label>Product Name *</label>
              <input
                type="text"
                name="product_name"
                value={productData.product_name}
                onChange={handleChange}
              />
              {errors.product_name && (
                <span className="barrels_error">{errors.product_name}</span>
              )}
            </div>

            <div className="barrels_form-group">
              <label>Unit of Measure *</label>
              <input
                type="text"
                name="uom"
                value={productData.uom}
                onChange={handleChange}
              />
              {errors.uom && (
                <span className="barrels_error">{errors.uom}</span>
              )}
            </div>

            {/* STATUS */}
            <div className="barrels_form-group">
              <label>Status</label>
              <select
                name="is_active"
                value={productData.is_active}
                onChange={(e) =>
                  setProductData({
                    ...productData,
                    is_active: Number(e.target.value),
                  })
                }
              >
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>
          </div>

          {/* FOOTER */}
          <div className="barrels_popup-footer">
            <button
              className="barrels_btn barrels_btn-save"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>

            <button
              className="barrels_btn barrels_btn-cancel"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
        >
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default AddProduct;